import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LimitCardProgressBar = ({
  limit
}) => {
  const {
    usage,
    limit: currentLimit,
    limitName
  } = limit;

  //fix for portals with older versions of the hubspot-free parcel
  const correctedCurrentLimit = currentLimit !== null && currentLimit !== void 0 ? currentLimit : 2500;
  const percentageOfLimitUsed = usage / correctedCurrentLimit * 100;
  const progressBarColorProp = percentageOfLimitUsed >= 100 ? 'danger' : percentageOfLimitUsed > 33 ? 'warning' : 'success';
  const remainingUsage = correctedCurrentLimit - usage;
  const progressBarLabelI18nKey = remainingUsage ? `limitUsageComponents.limits.${limitName}.remainingUsagePlural` : `limitUsageComponents.limits.${limitName}.limitReached`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        marginBlockEnd: "200",
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineEnd: "200",
          minInlineSize: "fit-content",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `limitUsageComponents.limits.${limitName}.progressBarCount`,
            options: {
              usage,
              limit: correctedCurrentLimit
            }
          })
        }), /*#__PURE__*/_jsx(View, {
          as: "span",
          minInlineSize: "fit-content",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: progressBarLabelI18nKey,
            options: {
              count: remainingUsage
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Progress
    //When the "danger" (red) color is used, the value prop behaves as the starting point where the bar gets colored,
    //so to color the entire bar, the value has to be 0.
    , {
      value: percentageOfLimitUsed >= 100 ? 0 : percentageOfLimitUsed,
      use: progressBarColorProp,
      inlineSize: "100%"
    })]
  });
};
export default LimitCardProgressBar;